
import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import PositioningStatement from './components/PositioningStatement';
import Industries from './components/Industries';
import Framework from './components/Framework';
import Outcome from './components/Outcome';
import ExecutiveCTA from './components/ExecutiveCTA';
import Footer from './components/Footer';
import Navbar from './components/Navbar';

export default function Home() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="relative">
      <Navbar isScrolled={isScrolled} />
      <Hero />
      <PositioningStatement />
      <Industries />
      <Framework />
      <Outcome />
      <ExecutiveCTA />
      <Footer />
    </div>
  );
}
